import React from 'react';
import {I18n} from 'react-redux-i18n';

import {Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  WithStyles,
  withStyles} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {useDispatch, useSelector} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router-dom';
import {CustomButton} from '../../material-dashboard-pro-react/components';

import Dropdown from '../Dropdown/Dropdown';

import {style} from './style';
import {AppStoreType} from '../../utils/store';
import {switchOrganization} from '../../actions/userOrganizations/switchOrganization';

type OrgSelectionPopupProps = WithStyles & RouteComponentProps & {
  entityType: string;
  open: boolean;
  onClose: () => void;
};

function OrgSelectionPopup({
  classes,
  entityType,
  open,
  onClose = () => { },
  history,
}: OrgSelectionPopupProps) {
  const dispatch = useDispatch();
  const organizations: {id: string; name: string}[] =
    useSelector((store: AppStoreType) => store.userOrganizationsReducer.userOrganizations);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{paper: classes.dialogPaper}}
    >
      <IconButton className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
      <DialogTitle className={classes.title}>{I18n.t('orgSelectionPopup.selectOrg')}</DialogTitle>

      <DialogContent className={classes.content}>
        <p className={classes.text}>
          {I18n.t('orgSelectionPopup.text', {entityType})}
        </p>

        <div className={classes.dropdown}>
          <Dropdown
            fullWidth={true}
            placeholder={I18n.t('orgSelectionPopup.selectOrg')}
            onChangeValue={(e) => {
              onClose();
              const orgIndex = e.target.value;
              (switchOrganization(organizations[orgIndex]))(dispatch);
            }}
            options={organizations.map((o) => o.name)}
            selectedItemIndex={-1}
          />
        </div>

        <p className={classes.text_bold}>
          {I18n.t('orgSelectionPopup.or')}
        </p>

        <CustomButton
          color="secondary"
          onClick={() => {
            onClose();
            history.push('/organizations?newOrg=true');
          }}
        >
          {I18n.t('orgSelectionPopup.createOrg')}
        </CustomButton>
      </DialogContent>
    </Dialog>
  );
}

export default withRouter(withStyles(style)(OrgSelectionPopup));
